module.exports = __webpack_public_path__ + "img/sub10.bfe13d30.jpg";